import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat({ message = "Hi Zelo, I'm interested in your spaces." }) {
  const number = "918758115155";
  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-30 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-400/40 animate-ping" />
      <span className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-emerald-500 text-white shadow-2xl hover:bg-emerald-600 transition-all duration-300 hover:scale-[1.03] active:scale-95">
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-semibold hidden sm:inline">Chat with Zelo</span>
      </span>
    </a>
  );
}
